import React from 'react';
import styled from 'styled-components';

import typograf from '../../../utils/typograf';
import mediaWidth from '../../../utils/mediaWidth/mediaWidth';
import { Font, FontWeight } from '../../../utils/fonts';

import FilledButton from '../../../common/FilledButton';
import FadeInAnimation from '../../../common/FadeInAnimation/FadeInAnimation';
import BaseButton from '../../../common/BaseButton';

import CloseIcn from '../assets/close-icn.png';
import PartyImage from '../assets/party.png';

class Final extends React.PureComponent {
    render() {
        const {
            handleClosePopUp,
            openForm,
        } = this.props;
        return (
            <Container>
                <CloseButton src={CloseIcn} onClick={handleClosePopUp} />
                <Content>
                    <Image src={PartyImage} />
                    <Title>Поздравляем!</Title>
                    <Text>{typograf.execute('Вы прошли все этапы и запустили актуальный и востребованный продукт!')}</Text>
                    <Text>{typograf.execute('Свяжитесь с нами, чтобы узнать, как поддерживать и развивать его дальше')}</Text>
                    <ButtonWrapper>
                        <FadeInAnimation delay="1" duration="0.5">
                            <Btn
                                onClick={openForm}
                            >
                                Обсудить задачу
                            </Btn>
                        </FadeInAnimation>
                        <FadeInAnimation delay="1" duration="0.5">
                            <RepeatBtn
                                onClick={handleClosePopUp}
                            >
                                пройти еще раз
                            </RepeatBtn>
                        </FadeInAnimation>
                    </ButtonWrapper>
                </Content>
            </Container>
        );
    }
}

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #FFF;
  
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
`;

const CloseButton = styled.img`
  width: 20px;
  height: 20px;
  
  position: absolute;
  top: 16px;
  right: 16px;
  
  cursor: pointer;
  
  ${mediaWidth.m} {
    top: 34px;
    right: 34px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  
  align-items: center;
  
  align-self: center;
  ${FontWeight.REGULAR};
`;

const Image = styled.img`
  width: 128px;
  height: 128px;
  margin: 0 auto;
  //border-radius: 0 0;

  ${mediaWidth.m} {
    width: 160px;
    height: 160px;
  }

  ${mediaWidth.xl} {
    width: 190px;
    height: 190px;
  }
`;

const Title = styled.div`
  margin-top: 40px;
  text-align: center;
  text-transform: uppercase;
  
  color: #000;
  ${Font.HEADLINE};
  font-size: 32px;
  line-height: 32px;

  ${mediaWidth.m} {
    margin-top: 56px;
    font-size: 56px;
    line-height: 56px;
  }

  ${mediaWidth.xl} {
    font-size: 64px;
    line-height: 64px;
  }
`;

const Text = styled.div`
  margin-top: 24px;
  width: 328px;

  color: rgba(0, 0, 0, 0.64);
  text-align: center;
  ${Font.PRIMARY};
  font-size: 16px;
  line-height: 24px;

  ${mediaWidth.m} {
    margin-top: 32px;
    width: 560px;
    font-size: 20px;
    line-height: 28px;
  }

  ${mediaWidth.xl} {
    margin-top: 56px;
    font-size: 24px;
    line-height: 32px;
  }
`;

const ButtonWrapper = styled.div`
  ${mediaWidth.m} {
    margin-top: 56px;
    width: 640px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }

  ${mediaWidth.l} {
    margin-top: 48px;
    width: 666px;
  }

  ${mediaWidth.l} {
    margin-top: 72px;
    width: 731px;
  }
`;

const Btn = styled(FilledButton)`
  margin-top: 40px;
  width: 328px;
  height: 63px;

  ${mediaWidth.m} {
    margin: 0;
    width: 308px;
    height: 63px;
  }

  ${mediaWidth.l} {
    width: 321px;
    height: 63px;
  }

  ${mediaWidth.xl} {
    width: 355px;
    height: 71px;
  }
`;

const RepeatBtn = styled(BaseButton)`
  margin-top: 16px;
  width: 328px;
  height: 63px;

  border: 2px solid #000000;

  ${mediaWidth.m} {
    margin: 0;
    width: 308px;
    height: 63px;
  }

  ${mediaWidth.l} {
    width: 321px;
    height: 63px;
  }

  ${mediaWidth.xl} {
    width: 355px;
    height: 71px;
  }
`;

export default Final;
